module.exports = __webpack_public_path__ + "static/img/backgroundHome1.510962d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backgroundHome1.png
// module id = yIu9
// module chunks = 13